/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.payments', {
            parent: 'board.dinghy.event.detail',
            url: '/payments?type',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER', 'ROLE_FINANCE'],
                pageTitle: 'askApp.project.payment.title'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/payments/payments.html',
                    controller: 'DinghyEventPaymentsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                type: {
                    value: 'all',
                    squash: true
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.dinghy.event.detail.payments.edit', {
            parent: 'board.dinghy.event.detail.payments',
            url: '/{paymentId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/dinghy/event/detail/payments/payment-dialog.html',
                    controller: 'DinghyEventPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['BoardPayment', function(BoardPayment) {
                            return BoardPayment.get({id : $stateParams.paymentId}).$promise;
                        }],
                        entityDinghyEvent: entity
                    }
                }).result.then(function() {
                    $state.go('board.dinghy.event.detail.payments', null, { reload: 'board.dinghy.event.detail.payments' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
